import { axiosInstance } from '../request';
export const getSummaryList = async () => {
    const response = await axiosInstance.get('/api/v1/summary');
    return response.data;
};
export const createSummary = async (data) => {
    const response = await axiosInstance.post('/api/v1/summary', data);
    return response.data;
};
export const getSummaryContent = async (id) => {
    const response = await axiosInstance.get(`/api/v1/summary/${id}`);
    return response.data;
};
export const updateSummaryContent = async (id, data) => {
    const response = await axiosInstance.patch(`/api/v1/summary/${id}`, data);
    return response.data;
};
export const deleteSummary = async (id) => {
    await axiosInstance.delete(`/api/v1/summary/${id}`);
};
export const getSummaryState = async (id) => {
    const response = await axiosInstance.get(`/api/v1/summary/${id}/state`);
    return response.data;
};
export const updateSummaryState = async (id, data) => {
    const response = await axiosInstance.patch(`/api/v1/summary/${id}/state`, data);
    return response.data;
};
export const getSummaryPromptSettings = async (id) => {
    const response = await axiosInstance.get(`/api/v1/summary/${id}/prompt`);
    return response.data;
};
export const updateSummaryPromptSettings = async (id, data) => {
    const response = await axiosInstance.patch(`/api/v1/summary/${id}/prompt`, data);
    return response.data;
};
export const replaySummary = async (id) => {
    const response = await axiosInstance.post(`/api/v1/summary/${id}/replay`);
    return response.data;
};
export const cancelReplaySummary = async (id) => {
    const response = await axiosInstance.post(`/api/v1/summary/${id}/replay/cancel`);
    return response.data;
};
export const resetSummaryPrompt = async (id) => {
    const response = await axiosInstance.post(`/api/v1/summary/${id}/prompt/reset`);
    return response.data;
};
export const resetSummaryPromptSettings = async (id) => {
    const response = await axiosInstance.post(`/api/v1/summary/${id}/prompt/settings/reset`);
    return response.data;
};
//# sourceMappingURL=summary.api.js.map